export function agentMatchesQuery(agent, query) {
  const normalizedQuery = query.trim().toLowerCase()
  if (!normalizedQuery) return true

  return [agent.name, agent.description].some((value) => {
    return (value || "").toLowerCase().includes(normalizedQuery)
  })
}
